var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseList',{attrs:{"list-query":_vm.places,"route":"place","locale-section":"pages.places"}})
}
var staticRenderFns = []

export { render, staticRenderFns }